export const TX_HISTORY_KEY = 'tx-history-v1';
export const isBrowser = typeof globalThis !== 'undefined' && 'localStorage' in globalThis;
export function readTxHistoryFromStorage() {
    if (!isBrowser)
        return {};
    try {
        const raw = localStorage.getItem(TX_HISTORY_KEY);
        if (!raw)
            return {};
        const parsed = JSON.parse(raw);
        Object.keys(parsed || {}).forEach((chain) => {
            parsed[chain] = (parsed[chain] || []).map((tx) => ({
                ...tx,
                createdAt: new Date(tx.createdAt),
                updatedAt: new Date(tx.updatedAt),
            }));
        });
        return parsed;
    }
    catch {
        return {};
    }
}
export function jsonSafeNftMetadata(info) {
    const out = { ...info };
    for (const key of Object.keys(out)) {
        const v = out[key];
        if (typeof v === 'bigint') {
            out[key] = v.toString();
        }
    }
    out.price = Number(out.price ?? 0);
    out.tokenId =
        out.tokenId != null && typeof out.tokenId !== 'object' ? String(out.tokenId) : out.tokenId;
    return out;
}
export function readFavoriteIdsFromStorage(key) {
    if (!isBrowser)
        return [];
    try {
        const raw = localStorage.getItem(key);
        if (raw == null || raw === '')
            return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed))
            return [];
        return parsed.filter((item) => typeof item === 'string');
    }
    catch {
        return [];
    }
}
